import { PlaceholderPage } from './PlaceholderPage';

export const ApprovalWorkflowsPage = () => <PlaceholderPage title="Approval Workflows" />;
